import '../SuccessModal/SuccessModal.css';
import '../Modal/Modal.css';
import Spinner from '../Spinner/Spinner';
import { IoClose } from 'react-icons/io5';
import { useId, useRef } from 'react';
import useModalErisim from '../../hooks/useModalErisim';

export default function WarningModal({
    isOpen = false,
    title,
    message,
    onClose,
    onConfirm,
    onSecondary,
    onCloseText,
    onConfirmText,
    onSecondaryText,
    isLoading = false,
    loadingConfirmText = "İşlem yapılıyor...",
    showCloseButton = false
}) {
    // FE-80: dialog rolü, Esc (işlem sürmüyorsa) = kapat/vazgeç, Tab döngüsü, odak geri.
    const pencereRef = useRef(null);
    const baslikId = useId();
    useModalErisim(isOpen, pencereRef, isLoading ? undefined : onClose, !isLoading);
    if (!isOpen) return null;

    // Tek buton gösterildiğinde o buton YEŞİL (confirm) stiliyle çıkar; iptal/kapat gibi ikincil
    // butonlar yalnız birden fazla buton varken gri (cancel) kalır.
    const buttonCount = [onCloseText, onSecondaryText, onConfirmText].filter(Boolean).length;
    const secondaryButtonClass = buttonCount === 1
        ? "success-modal__button success-modal__button--confirm"
        : "success-modal__button success-modal__button--cancel";

    const handleOverlayMouseDown = (event) => {
        if (isLoading) return;
        if (event.target === event.currentTarget) {
            onClose?.();
        }
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 2002 }} onMouseDown={handleOverlayMouseDown}>
            <div className="success-modal" ref={pencereRef} role="alertdialog" aria-modal="true" tabIndex={-1} aria-labelledby={baslikId}>
                {showCloseButton && (
                    <button
                        className="modal-close-button"
                        onClick={onClose}
                        aria-label="Kapat"
                        disabled={isLoading}
                    >
                        <IoClose size={20} />
                    </button>
                )}
                <h2 className="success-modal__title" id={baslikId}>{title}</h2>
                <p className="success-modal__message">{message}</p>
                <div className="success-modal__actions">
                    {onCloseText &&
                        <button
                            className={secondaryButtonClass}
                            onClick={onClose}
                            disabled={isLoading}
                            style={{
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? "not-allowed" : "pointer"
                            }}
                        >
                            {onCloseText}
                        </button>
                    }

                    {onSecondaryText &&
                        <button
                            className={secondaryButtonClass}
                            onClick={onSecondary}
                            disabled={isLoading}
                            style={{
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? "not-allowed" : "pointer"
                            }}
                        >
                            {onSecondaryText}
                        </button>
                    }

                    {onConfirmText &&
                        <button
                            className="success-modal__button success-modal__button--confirm"
                            onClick={onConfirm}
                            disabled={isLoading}
                            style={{
                                opacity: isLoading ? 0.85 : 1,
                                cursor: isLoading ? "wait" : "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px"
                            }}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner size={16} color="#ffffff" />
                                    <span>{loadingConfirmText}</span>
                                </>
                            ) : (
                                onConfirmText
                            )}
                        </button>
                    }

                </div>
            </div>
        </div>
    );
}
